<template>
	<div>
		<slot name="titles"></slot>

		<div class="row flex-stretch mt-10">
			<div class="usp usp-faq">
				<div class="usp-title">
					<img src="../assets/img/badges/plans/calendar-grey.png" class="usp-icon" v-if="template === 'plans'">
					<img src="../assets/img/badges/recipes/piatti-unici.png" class="usp-icon" v-if="template === 'recipes'">
					<img src="../assets/img/badges/team/gusto.png" class="usp-icon" v-if="template === 'team'">
					<img src="../assets/img/badges/tag/buono.svg" class="usp-icon" v-if="template === 'tag'">
					<img src="../assets/img/badges/box/delivery-express.png" class="usp-icon usp-icon-delivery" v-if="template === 'box'">
					<img src="https://api.quomi.it/oldimg/recommended.png" class="usp-icon usp-icon-delivery" v-if="template === 'box-checkout'">
				</div>
				<div class="usp-content text-uppercase">
					{{ $t("components.usp." + template + ".usp_title_one") }}
				</div>
				<div class="usp-content">
					{{ $t("components.usp." + template + ".usp_one") }}
				</div>
			</div>

			<div class="usp usp-faq">
				<div class="usp-title">
					<img src="../assets/img/badges/plans/contract-grey.png" class="usp-icon" v-if="template === 'plans'">
					<img src="../assets/img/badges/recipes/harvest.png" class="usp-icon" v-if="template === 'recipes'">
					<img src="../assets/img/badges/team/ambiente.png" class="usp-icon" v-if="template === 'team'">
					<img src="../assets/img/badges/tag/veloce.svg" class="usp-icon" v-if="template === 'tag'">
					<img src="../assets/img/badges/box/office.png" class="usp-icon" v-if="template === 'box'">
					<img src="https://api.quomi.it/oldimg/restaurant.png" class="usp-icon usp-icon-delivery" v-if="template === 'box-checkout'">

				</div>
				<div class="usp-content text-uppercase">
					{{ $t("components.usp." + template + ".usp_title_two") }}
				</div>
				<div class="usp-content">
					{{ $t("components.usp." + template + ".usp_two") }}
				</div>
			</div>

			<div class="usp usp-faq">
				<div class="usp-title">
					<img src="../assets/img/badges/plans/delivery-grey.png" class="usp-icon usp-icon-delivery" v-if="template === 'plans'">
					<img src="../assets/img/badges/recipes/gusto-mediterraneo.png" class="usp-icon" v-if="template === 'recipes'">
					<img src="../assets/img/badges/team/salute.png" class="usp-icon" v-if="template === 'team'">
					<img src="../assets/img/badges/tag/facile.svg" class="usp-icon" v-if="template === 'tag'">
					<img src="../assets/img/badges/box/delivery.png" class="usp-icon usp-icon-delivery" v-if="template === 'box'">
					<img src="https://api.quomi.it/oldimg/menu.png" class="usp-icon usp-icon-delivery" v-if="template === 'box-checkout'">
				</div>
				<div class="usp-content text-uppercase">
					{{ $t("components.usp." + template + ".usp_title_three") }}
				</div>
				<div class="usp-content">
					{{ $t("components.usp." + template + ".usp_three") }}
				</div>
			</div>
		</div>
	</div>
</template>

<script type = "text/javascript" >

export default {
	props: {
		template: {
			type: String,
			default: 'plans'
		}
	}
}

</script>

<style scoped>

.usp {
	margin: 20px 0;
	flex-grow: 1;
	min-width: 275px;
	flex-basis: calc(100% / 3 - 20px);
	border: none !important;
}

.text-uppercase {
	text-transform: uppercase;
}

.row {
	justify-content: space-around;
	margin: 0 -10px;
}

.usp-content {
	padding-top: 10px;
	text-align: center;
}

.usp-icon {
	max-width: 40px;
}

.usp-icon-delivery {
	max-width: 50px;
}

.usp-faq {
	margin: 20px 10px;
}

</style>
